import React, {useCallback, useEffect, useState} from 'react';
import {Layout, Table} from "antd";
import StrategiesSider from "./StrategiesSider";
import {Outlet} from "react-router-dom";
import {saveAsset} from "../portfolioAssets/assetsSlice";
import AdminStrategyDialog from "./AdminStrategyDialog";
const {Content, Sider} = Layout;

const initHelmet = {
    isRoot: false,
    description: 'Стратегии',
    title: 'I-Portfolio'
};

const StrategiesPage = () => {
    const [helmet] = useState(initHelmet);

    return(
        <>
            <Layout hasSider className='main-layout-wrapper'>
                <Sider>
                    <StrategiesSider />
                </Sider>
                <Content className='main-layout-content'>
                    <Outlet/>
                </Content>
            </Layout>
        </>
    )
}

export default StrategiesPage;
